import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";

export default async function addEquipmentToBookshelf(equipmentData, prefix) {
    const token = await getOrRefreshFirebaseToken();

    const res = await fetch(
        `${prefix}bookshelf/equipment`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(equipmentData),
        }
    );
    return res.json();
}